export { default } from './BensServicosConteudos';
